import React from 'react';
import PostJobTable from './PostJobTable';

const PostedJobs = () => {

    let columns = [["title", "name"], "vacancies", "endTimeFormat", "job_status"]
    let headers = ["Title", "Vacancies", "End Time", "Status"]

    return (
        <PostJobTable
            title="Manage Jobs"
            header={headers}
            url="post-jobs/"
            filters='fields=id,title,vacancies,job_status,preferred_qualification,amount,endTimeFormat,country'
            column={columns}
            view="emp-candidates"
            PJedit={true}
            makePayment={true}
            edit={false}
            finish={true}
            status={["Finish"]}
        />
    );
};

export default PostedJobs;